import { TextOnlySearchEditor } from "./TextOnlySearch";
import { ResourceSelector } from "./ResourceSelector";
import { ServerGroupSelectorProps } from "./ServerGroupSelector";
import { useCallback } from "react";
import { lbaSearchDef, lbaSortFields } from "../section/lba/def";
import { LbaListTable } from "../section/lba/LbaList";

export function LoadBalancerSelector({ editor, selectSingle, children, autoFocusSearch }: ServerGroupSelectorProps) {
    const memoSearchEditor = useCallback(
        (props) => <TextOnlySearchEditor {...props} autoFocus={!!autoFocusSearch} />,
        [autoFocusSearch]
    );

    return (
        <ResourceSelector
            selector={{
                editor,
                selectSingle,
            }}
            kind='load_balancer'
            sortFields={lbaSortFields}
            searchDef={lbaSearchDef}
            searchComponent={memoSearchEditor}
            table={LbaListTable}
            context='selector'
        >
            {children}
        </ResourceSelector>
    );
}